import Flux from 'lib/flux';
import ContactService from 'services/contact';
import ContactConstants from 'constants/contact';

const ContactActionCreator = Flux.createActionCreator({
  sendMessage(message) {
    let self;
    let onFullfilled;
    let onRejected;
    self = this;
    onFullfilled = function (resp) {
      self.dispatchAction(ContactConstants.SEND_MESSAGE_COMPLETED);
    };
    onRejected = function (resp) {
      const payload = { errors: { base: 'Something went wrong.' } };
      self.dispatchAction(ContactConstants.SEND_MESSAGE_FAILED, payload);
    };

    this.dispatchAction(ContactConstants.SEND_MESSAGE);
    ContactService.sendMessage(message).then(onFullfilled, onRejected);
  },
});

export default ContactActionCreator;
